// Auto-fix for hot reload clicking issues
export const initHotReloadFix = () => {
  // Only run in development mode
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  // Function to clean up blocking overlays
  const fixClickBlocking = () => {
    // // Remove high z-index fixed elements (error overlays, blocking iframes)
    document.querySelectorAll('[style*="position: fixed"]').forEach(el => {
      const zIndex = parseInt(getComputedStyle(el).zIndex) || 0;
      if (zIndex > 1000) {
        // eslint-disable-next-line no-console
        console.log('🔧 [JUST FOR DEV] Removing blocking overlay:', el);
        el.remove();
      }
    });

    // // Press Escape to dismiss React error states
    // document.dispatchEvent(new KeyboardEvent('keydown', {
    //   key: 'Escape',
    //   keyCode: 27,
    //   which: 27
    // }));

    // Additional cleanup for Sentry/other blocking elements
  //   document.querySelectorAll('iframe[style*="z-index: 2147483647"]').forEach(el => {
  //     // eslint-disable-next-line no-console
  //   console.log('🔧 Removing blocking iframe:', el);
  //     el.remove();
  //   });

  //   // eslint-disable-next-line no-console
  //   console.log('🎯 Auto-fixed clicking issue after hot reload');
  // };

  // // Auto-run fix after hot reload completes
  // if (module.hot) {
  //   module.hot.accept(() => {
  //     setTimeout(fixClickBlocking, 100); // Small delay to let hot reload finish
  //   });
  }

  // Listen for webpack hot reload messages
  // if (typeof window !== 'undefined') {
  //   // Hook into React's error overlay dismissal
  //   const originalTryDismissErrorOverlay = window.tryDismissErrorOverlay;
  //   window.tryDismissErrorOverlay = function() {
  //     if (originalTryDismissErrorOverlay) {
  //       originalTryDismissErrorOverlay.apply(this, arguments);
  //     }
  //     setTimeout(fixClickBlocking, 200);
  //   };

    // Listen for hot reload success events
    // window.addEventListener('message', (event) => {
    //   if (event.data && event.data.type === 'FAST_REFRESH') {
    //     setTimeout(fixClickBlocking, 300);
    //   }
    // });

    // // Backup: run fix every 2 seconds in development only
    if (process.env.NODE_ENV !== 'production') {
      let lastCheck = 0;
      setInterval(() => {
        // Only run if it's been a while since last check (to avoid spam)
        if (Date.now() - lastCheck > 5000) {
          const hasProcessError = document.querySelector('[style*="z-index"][style*="position: fixed"]');
          if (hasProcessError) {
            fixClickBlocking();
            lastCheck = Date.now();
          }
        }
      }, 2000);
    }

    // // Manual fix function available in console
    // window.fixClickBlocking = fixClickBlocking;
  // }
};

export default initHotReloadFix;
